import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { API_ENDPOINT } from '../../index';

import {
    Row,
    Col,
    Popover,
    Button,
    Popconfirm,
    DatePicker,
    Input
} from 'antd'

const { Search } = Input;

class SelectSupplierModalContent extends React.Component {

    constructor(props) {
        super(props);
    }

    

    render(){
        return(
            
            <Col style={{height:"50vh", overflow:"auto", width:"100%"}}>
                {
                    Array.isArray( this.props.suppliers ) &&
                    this.props.suppliers.length > 0 &&
                    this.props.suppliers.map(_supplier=>
                        <Row 
                            type="flex" 
                            justify="space-between" 
                            align="middle" 
                            style={{
                                padding:"10px", 
                                width:"100%",
                                backgroundColor: `${ this.props.selectedSupplier === _supplier._id ? "#91d5ff" : "#ffff" }`,
                                borderRadius:"2px"
                            }}
                        >

                            <Col type="flex" justify="space-around" align="start" span={12} style={{padding:"5px"}}  >
                                <Row>{ _supplier.details.name }</Row>
                                <Row>{ _supplier.details.companyName }</Row>
                                <Row>{ _supplier.details.address }</Row>
                                <Row>{ _supplier.details.email }</Row>
                            </Col>
                            <Col span={3} style={{padding:"5px"}}  >
                                <Button 
                                    icon="check" 
                                    type={ this.props.selectedSupplier === _supplier._id ? "primary" : "default" } 
                                    onClick={()=>this.props.onSelectSupplier(_supplier._id)} 
                                />
                            </Col>
                            
                        </Row>
                    )
                }

            </Col>
            
        )
    }


    shouldComponentUpdate(nextProps){

        if( this.props.toggleSelectSupplierModal != nextProps.toggleSelectSupplierModal ){
            return true
        }
        
        if( this.props.selectedSupplier != nextProps.selectedSupplier ){
            return true
        }

        
        console.log( nextProps.suppliers )
        let currentSuppliers = Array.isArray(this.props.suppliers) ? this.props.suppliers.map(a=>a._id) : []
        let nextSuppliers = Array.isArray(nextProps.suppliers) ? nextProps.suppliers.map(a=>a._id) : []

        if( currentSuppliers.sort().join() != nextSuppliers.sort().join()  ){
            return true
        }

        return false
    }



}
export default SelectSupplierModalContent;


// WEBPACK FOOTER //
// ./src/components/delivery-page/SelectSupplierModalContent.js